<div
  id="sidebar-left"
  class="closed"
  [ngClass]="{ closed: !this.open }"
>
  <div class="top-bar">
    <div class="logo-bg">
      <i
        class="napp-logo napp-logo-brand"
        [class.animate]="this.open"
      ></i>
    </div>
  </div>
  <dx-button
    (click)="close()"
    icon="fas fa-times"
    id="close-icon"
  ></dx-button>
  @if (isLoading | async) {
    <dx-load-indicator
      class="item-loader"
      height="20"
      width="20"
    ></dx-load-indicator>
  }

  @if (this.renderMenu) {
    <nav id="left-menu">
      <ng-container *ngTemplateOutlet="menuTree; context: { $implicit: combinedMenu }"></ng-container>
    </nav>
  }

  <ng-template
    #menuTree
    let-items
  >
    <ul>
      @for (item of items; track item.id || item.title || $index) {
        @if (item.moduleEnabled && checkPermission(item.requiredScopes)) {
          <li [class.menu-divider]="item.classNames?.includes('menu-divider')">
            @if (item.childs && item.childs.length > 0) {
              <span>{{ item.title }}</span>
              <ng-container *ngTemplateOutlet="menuTree; context: { $implicit: item.childs }"></ng-container>
            } @else {
              <a
                [routerLink]="
                  item.id === 'action-add-page'
                    ? ['/site/add']
                    : item.id === 'documents-root'
                      ? ['/mediadirectories/add']
                      : item.id
                        ? [item.modulePath?.path, item.id]
                        : [item.modulePath?.path]
                "
                [queryParams]="item.modulePath?.queryParams"
                (click)="close()"
              >
                {{ item.title }}
              </a>
            }

            @if (hasActions(item) && item.id !== 'action-add-page') {
              <i
                class="fas fa-ellipsis-v more-icons"
                (click)="toggleActions($event, item)"
              ></i>
            }
          </li>

          @if (activeActionMenuId === (item.id ?? item.title) && hasActions(item)) {
            <div class="menu-site-actions mm-nopanel mm-nolistview">
              @for (action of item.siteActions; track $index) {
                <li
                  class="site-actions"
                  (click)="executeAction(action, item)"
                >
                  <i [class]="action.icon"></i> {{ action.name }}
                </li>
              }
            </div>
          }
        }
      }
    </ul>
  </ng-template>

  <div class="version-container">
    <small class="version">version:&nbsp;{{ version }}</small>
  </div>
</div>
